import {addClass} from "codemirror/src/util/dom";

global.$ = global.jQuery = require('jquery');

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
window.Swiper = Swiper;

import Headroom from "headroom.js";

import AOS from 'aos';
import 'aos/dist/aos.css';

import fslightbox from "fslightbox";


$(document).ready(function() {

    AOS.init({
        delay: 300,
        duration: 600,
        once: true,
    });

    // sticky scroll menu
    if ($('.headroom').length > 0) {
        let headroomEl = document.querySelector("header");
        let headroomOpt = {
            offset: 150,
        }
        let headroom = new Headroom(headroomEl, headroomOpt);
        headroom.init();
    }

    const blogSwiper = new Swiper('#homePostsSlider', {

        loop: true,
        breakpoints: {
            767: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            578: {
                slidesPerView: 1,
                spaceBetween: 20
            }
        },

        // Navigation arrows
        navigation: {
            nextEl: '.blog-swiper-button-next',
            prevEl: '.blog-swiper-button-prev',
        },
    });

    // faq accordeon
    $('.js-accordion-title').on('click', function () {
        $(this).next().slideToggle(200);
        $(this).toggleClass('open', 200);
    });
    // To-top button
    const toTopBtn = $('#to-top');
    $(window).scroll(function () {
        if ($(window).scrollTop() > 300) {
            toTopBtn.fadeIn();
        } else {
            toTopBtn.fadeOut();
        }
    });

    toTopBtn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 'slow');
    });

    /* questo js gestisce la ricerca dei prodotti dalla navbar */
    let typingTimer;                //timer identifier
    let doneTypingInterval = 5000;  //time in ms, 5 seconds for example
    let inputField = $("#searchBtn");


    let timer;
    const inputSearchBtn = document.querySelector('#searchBtn');
    inputSearchBtn.addEventListener('keyup', () => {

        clearTimeout(timer);

        timer = setTimeout(() => {
            let valueInput = $("#searchBtn").val();
            if (valueInput.length >= 3) {
                $('#result').empty();
                $("#loaderSearch").toggleClass("d-none");
                if (valueInput !== "") {
                    $.request("searchProducts::onSearchProductList", {
                        data: {q: valueInput},
                        complete: function (data) {
                            $("#loaderSearch").toggleClass("d-none");
                            $('#result').show();
                            $("#result").css("height", $("#result").height() + "px");
                        }
                    });
                } else {
                    $("#loaderSearch").toggleClass("d-none");
                    $('#result').empty();
                }
            }
        }, 500);
    });


    let searchBtnMobile = $("#searchBtnMobile");
    searchBtnMobile.keyup(function () {
        let valueInputMobile = $(this).val();
        if (valueInputMobile.length >= 3) {
            $('#resultSearchShopMobile').empty();
            $("#loaderSearch").toggleClass("d-none");
            if (valueInputMobile !== "") {
                $.request("searchProducts::onSearchProductList", {
                    data: {q: valueInputMobile, mobile: true},
                    complete: function (data) {
                        $("#resultSearchShopMobile").css("height", $("#resultSearchShopMobile").height() + 15 + "px");
                        $('#containerSearchMobile').removeClass("translateSearch");

                        $("#chiudiRicerca").on("click", function () {
                            $('#containerSearchMobile').addClass("translateSearch");
                        });
                    }
                });
            }
        }
    });

    /* questo js gestisce la ricerca dei paesi */
    let zoneSearchInput = $("#searchZoneBtn");
    let zoneSearchMobileInput = $("#searchZoneMobileBtn");

    zoneSearchInput.keyup(function () {
        let valueZone = $(this).val();
        $.request("locationsList::onSearchZoneList", {
            data: {q: valueZone},
            complete: function (data) {
                $('#locationResults').replaceWith(data.locationResults);
            }
        });
    });

    zoneSearchMobileInput.keyup(function () {
        let valueZone = $(this).val();
        $.request("locationsList::onSearchZoneList", {
            data: {q: valueZone},
            complete: function (data) {
                $('#locationResultsMobile').replaceWith(data.locationResults);
            }
        });
    });


    /*viene posizionato dinamicamente il pannello del cerca rispetto all'altezza della barra sopra*/
    $("#collapseSearch").css("top", $(".header").height());
    $("#collapseZoneChanger").css("top", $(".header").height());
    // $(".right-menu-item").hover( function(e) {
    //     $(this).find(".collapse").collapse('toggle');
    //     e.stopPropagation();
    // });


    let linkProd = $(".products-link");
    let linkColl = $(".collections-link");
    let linkFor = $(".fornace-link");

    let linkProdA = $(".products-link a");
    let linkCollA = $(".collections-link a");
    let linkForA = $(".fornace-link a");

    let contProdDesk = $("#menuProductsDesktop");
    let contCollDesk = $("#menuCollectionsDesktop");
    let contForDesk = $("#menuFornaceDesktop");

    let linkCurrancy = $('#apriModaleMobile');
    let contCurrancy = $('#menuLangMobile')

    // menu mobile
    let burgerBtn = $('.burger-btn');
    let menuMobile = $('#menu-mobile');
    let closerBtn = $('#closer-button');
    let backButtonSub = $('.back-button-sub');
    let closerButtonSub = $('.closer-button-sub');
    let menuProdMobile = $('#menuProdMobile');
    let menuCollMobile = $('#menuCollMobile');
    let menuForMobile = $('#menuForMobile');

    if ($(window).width() >= 1200) {

        openCloseSubMenu(linkProd, linkProdA, contProdDesk)
        openCloseSubMenu(linkColl, linkCollA, contCollDesk)
        openCloseSubMenu(linkFor, linkForA, contForDesk)

    } else {
        burgerBtn.on('click', function () {
            menuMobile.stop().slideDown(300);
            menuMobile.addClass('d-block')
            $('body').addClass('overflow-hidden');
        });

        closerBtn.on('click', function () {
            menuMobile.stop().removeClass('d-block')
            menuMobile.slideUp(300);
            $('body').removeClass('overflow-hidden');
        });

        closerButtonSub.on('click', function () {
            menuMobile.stop().slideUp(300);
            menuMobile.removeClass('d-block')
            $('body').removeClass('overflow-hidden');
            if (menuProdMobile.css("right") === '0px') {
                menuProdMobile.animate({"right": '-100%'}, 300).delay(300);
            }
            if (contCurrancy.css("right") === '0px') {
                contCurrancy.animate({"right": '-100%'}, 300).delay(700);
            }
            rotativeX(closerBtn, 0);
            rotativeX(closerButtonSub, 0);
        });

        openSubMenuMobile(linkProd, menuProdMobile)
        openSubMenuMobile(linkColl, menuCollMobile)
        openSubMenuMobile(linkFor, menuForMobile)
        openSubMenuMobile(linkCurrancy, contCurrancy)
    }

    function openCloseSubMenu(link, linka, sub) {
        link.click(function (e) {
            e.preventDefault();
        })

        link.hover(function (e) {
            sub.stop().slideDown(400);
            sub.addClass('open')
            linka.addClass('color-gold')
            e.stopPropagation()
            // $('body').addClass('overflow-hidden');
        }, function (e) {
            sub.stop().slideUp(400);
            sub.removeClass('open')
            linka.removeClass('color-gold')
            e.stopPropagation()
            // $('body').removeClass('overflow-hidden');
        });

        sub.hover(function (e) {
            sub.stop().slideDown(400);
            linka.addClass('color-gold')
            // $('body').addClass('overflow-hidden');
            e.stopPropagation()
        }, function (e) {
            sub.stop().slideUp(400);
            e.stopPropagation()
            // $('body').removeClass('overflow-hidden');
            linka.removeClass('color-gold')
        });
    }

    function openSubMenuMobile(btn, menu) {
        btn.on('click', function (e) {
            e.preventDefault();
            menu.animate({"right": 0}, 300);
            rotativeX(closerBtn, 90);
            rotativeX(closerButtonSub, 90);
        });

        backButtonSub.on('click', function (e) {
            e.preventDefault();
            menu.animate({"right": '-100%'}, 300);
            rotativeX(closerBtn, -90);
            rotativeX(closerButtonSub, -90);
        });
    }

    let fornace49UlCloser = $('#fornace49UlCloser');
    let fornace49UlCloserBtn = $('#fornace49UlCloser .closer-button-mini');
    let fornace49Ul = $('#fornace49Ul');

    let serviziUlCloser = $('#serviziUlCloser');
    let serviziUlCloserBtn = $('#serviziUlCloser .closer-button-mini');
    let serviziUl = $('#serviziUl');

    let contractUlCloser = $('#contractUlCloser');
    let contractUlCloserBtn = $('#contractUlCloser .closer-button-mini');
    let contractUl = $('#contractUl');

    let restauroUlCloser = $('#restauroUlCloser');
    let restauroUlCloserBtn = $('#restauroUlCloser .closer-button-mini');
    let restauroUl = $('#restauroUl');

    openCloseMiniMenu(fornace49UlCloser, fornace49UlCloserBtn, fornace49Ul)
    openCloseMiniMenu(serviziUlCloser, serviziUlCloserBtn, serviziUl)
    openCloseMiniMenu(contractUlCloser, contractUlCloserBtn, contractUl)
    openCloseMiniMenu(restauroUlCloser, restauroUlCloserBtn, restauroUl)

    function openCloseMiniMenu(closer, closerBtn, ul) {
        closer.on('click', function (e) {
            e.preventDefault()
            if (closerBtn.hasClass('open')) {
                ul.stop().slideUp(300);
                closerBtn.removeClass('open')
            } else {
                ul.stop().addClass('open')
                ul.slideDown(300);
                closerBtn.addClass('open')
            }
        });

    }

    function rotativeX(elem, deg) {
        elem.animate(
            {deg: deg},
            {
                duration: 400,
                step: function (now) {
                    $(this).css({transform: 'rotate(' + now + 'deg)'});
                }
            }
        );
    }

    function isMobile() {
        const minWidth = 1200; // Minimum width for desktop devices
        return window.innerWidth < minWidth || screen.width < minWidth;
    }


    if (isMobile()) {
        window.sessionStorage.loadSuggested = undefined;
        $('.filter-text').on('click', function () {
            if ($('html, body').hasClass('stopScroll') && $('.cat-filters-wrapper').hasClass('translate0')) {
                $('html, body').removeClass('stopScroll');
            } else {
                $('html, body').addClass('stopScroll');
            }
            $('.cat-filters-wrapper').toggleClass('translate0', 800);
        });

        $(document).on('click', '.cat-filters-wrapper .filter-close', function () {
            if ($('html, body').hasClass('stopScroll') && $('.cat-filters-wrapper').hasClass('translate0')) {
                $('html, body').removeClass('stopScroll');
            } else {
                $('html, body').addClass('stopScroll');
            }
            $('.cat-filters-wrapper').toggleClass('translate0', 800);
        });

    } else {
        window.sessionStorage.loadSuggestedMobile = undefined;
    }

    // change footer opener icon
    let mobileFooterOpener = $('#mobileFooterOpener')
    let footerInfos = $('#footerInfos')

    mobileFooterOpener.click(function (e) {
        e.preventDefault()
        if (mobileFooterOpener.hasClass('open')) {
            footerInfos.stop().slideUp(300);
            mobileFooterOpener.removeClass('open')
        } else {
            footerInfos.stop().slideDown(300);
            mobileFooterOpener.addClass('open')
            let n = $(document).height();
            // console.log(n)
            $('html, body').animate({scrollTop: n}, 200);
        }
    })

    $('#changeSuggMobile').on('click', function (e) {
        e.preventDefault();
        suggModalMobile.hide();
        menuMobile.stop().slideDown(300);
        menuMobile.addClass('d-flex')
        $('body').addClass('overflow-hidden');
        contCurrancy.animate({"right": 0}, 300);
        rotativeX(closerBtn, 90);
        rotativeX(closerButtonSub, 90);
    });

    let techSwiper = new Swiper('.swiper_tech', {
        allowTouchMove: false,
        simulateTouch: false,
        speed: 600,
        slidesPerView: 1,
        effect: "creative",
        creativeEffect: {
            prev: {
                shadow: true,
                origin: "left center",
                translate: ["-5%", 0, -200],
                rotate: [0, 100, 0],
            },
            next: {
                origin: "right center",
                translate: ["5%", 0, -200],
                rotate: [0, -100, 0],
            },
        },
    });

    $('.tech-swiper-list a').on('mouseenter', function (e) {
        let attr = ($(this).attr('data-slide'));
        techSwiper.slideTo(attr - 1);
        if (!$(this).hasClass('active')) {
            $('.tech-swiper-list a').removeClass('active')
            $(this).addClass('active')
        }
    });

    let misureMoreBtn = $("#misure-more-btn");
    let misureMore = $("#misure-more");
    readMore(misureMoreBtn, misureMore);

    let descMoreBtn = $("#desc-more-btn");
    let descMore = $("#desc-more");
    readMore(descMoreBtn, descMore);

    function readMore(btn, description) {
        btn.on('click', function () {
            if (!description.hasClass("open")) {
                description.animate({height: '100%'}).addClass("open");
                description.show("slow");
            } else {
                description.animate({height: '21rem'}).removeClass("open");
                description.show("slow");
            }
        });
    }

    //BTN BACK
    $("#back_btn").click(function () {
        window.history.back();
    });

    let collapseSearch = document.getElementById('collapseSearch');
    collapseSearch.addEventListener('shown.bs.modal', event => {
        $("#searchBtn").focus();
    })




});

/* Code for dynamic input HoneyPot */
document.addEventListener('DOMContentLoaded', function () {

    const forms = document.querySelectorAll('form[data-mautic-form]');
    if (!forms.length) return;
    const startTime = Date.now();

    forms.forEach(function(form) {
        form.addEventListener('submit', function (event) {
            const inputAziendas = form.querySelectorAll('.inputAzienda input[type="text"], .inputAzienda textarea');

            for (let hp of inputAziendas) {
                if (hp.value && hp.value.trim() !== "") {
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                }

                const elapsed = (Date.now() - startTime) / 1000;
                if (elapsed < 4) {
                    console.log('quick')
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                }
            }
        });
    });

});
